module.exports = __webpack_public_path__ + "img/single-user-updated.87446d6e.svg";